import { useState } from "react";
import { Botao } from "../../../shared/components/Botao";
import { LoadingPage } from "../../../shared/components/LoadingPage";
import { PageHeader } from "../../../shared/components/PageHeader/PageHeader";
import { TableInfo } from "../../../shared/components/Table";
import { IconAdicionar } from "../../../shared/Icons/IconAdicionar";
import { IconsNotaFiscal } from "../../../shared/Icons/IconsNotaFiscal";
import { IconVisibility } from "../../../shared/Icons/IconVisibility";
import { SimpleFilter } from "../../Contatos/components/SimpleFilter";
import { NotaFiscalModal } from "../components/NotaFiscalModal";
import useGetNotasFiscais from "../hooks/useGetNotasFiscais";
import { colunas } from "../utils/ColumnTableNotas";
import { EditNotaFiscalModal } from "../components/EditNotaFiscalModal";
import { ConfirmDeleteModal } from "../../../shared/components/Modal/ConfirmDeleteModal";
import { Sidebar } from "../../../shared/components/MenuSidebar/Sidebar";
import { Navbar } from "../../../shared/components/Navbar";
import deleteNotaFiscal from "../queries/deleteNotaFiscal";

export function NotasFiscais() {
  const [visible, setVisible] = useState<boolean>(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [visibleDelete, setVisibleDelete] = useState(false);
  const [valueInput, setValueInput] = useState('');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState<number>(1);
  const [notaFiscalId, setNotaFiscalId] = useState<number>();

  const { data: notasFiscaisData, isLoading} = useGetNotasFiscais(search, page);

  const dataSourceNotaFiscal = notasFiscaisData?.items.map((notas: any) => ({
    key: notas.NotaFiscalId,
    ...notas,
  }))

  function getForEdit(record: any) {
    setNotaFiscalId(record.NotaFiscalId);
    setVisibleEdit(!visibleEdit);
  }

  async function onDelete() {
    notaFiscalId && await deleteNotaFiscal(Number(notaFiscalId))
    setVisibleDelete(!visibleDelete)
  }

  const columns = [
    ...colunas,
    {
      title: "Ações",
      dataIndex: "action",
      key: "action",
      width: 50,
      render: (text: any, record: any, index: any) => {
        return (
          <div className="flex gap-3">
            <button
              onClick={() => {
                getForEdit(record)
              }}
              className="bg-gray-400 hover:bg-primary-hover p-1 text-gray-100 rounded-full">
              <IconVisibility width="20" height="20" />
            </button>
          </div>
        );
      },
    }
  ]

  return (
    <div className="flex flex-row mx-auto">
      <div className="flex flex-row">
        <Sidebar />
        <Navbar />
      </div>
      <div className="flex flex-col pl-[10rem] w-[85%] mx-auto">
        <PageHeader
          titulo="Notas Fiscais"
          icon={<IconsNotaFiscal />}
          componente={
            <div className="flex gap-10">
              <SimpleFilter
                placeholder="Pesquisar nota fiscal"
                value={valueInput}
                onChange={(e: any) => setValueInput(e.target.value)}
                onClick={() => {
                  setSearch(valueInput);
                  if(valueInput) {
                    setPage(1);
                  }
                }}
                onCancel={() => {
                  setSearch('')
                  setValueInput('')
                }}
              />
              <Botao 
                texto="Novo" 
                icon={<IconAdicionar color="#fff" />} 
                onClick={() => setVisible(!visible)} 
                className="bg-primary hover:bg-primary-hover text-white" 
              />
            </div>
          }
        />

          {notaFiscalId ? <EditNotaFiscalModal 
            visible={visibleEdit}
            onCancel={() => {
              setNotaFiscalId(undefined);
              setVisibleEdit(!visibleEdit);
            }}
            notaFiscalId={notaFiscalId}
            deleteModal={() => {
              setVisibleDelete(!visibleDelete);
              setVisibleEdit(!visibleEdit);
            }}
          />
          : <NotaFiscalModal onCancel={() => setVisible(!visible)} visible={visible} />
          }
        

        {!notasFiscaisData ? 
          <div className="h-[80vh] flex justify-center items-center">
            <LoadingPage />
          </div> 
        : <TableInfo 
          loading={isLoading}
          columns={columns} 
          dataSource={dataSourceNotaFiscal} 
          pagination={{
            current: page,
            pageSize: notasFiscaisData?.meta?.itemsPerPage,
            total: notasFiscaisData?.meta?.totalItems,
            onChange(p) {
              setPage(p);
            },
          }}
          />
        }

        <ConfirmDeleteModal 
          isModalOpen={visibleDelete} 
          title="Excluir Nota Fiscal" 
          mensagem="Você tem certeza que desejar excluir essa Nota Fiscal?" 
          onDelete={onDelete} 
          closeModal={() => setVisibleDelete(!visibleDelete)} 
        />
      </div>
    </div>
  );
}
